import { httpsCallable } from "firebase/functions";

import { functions } from "./firebase";
import type {
  CreateCheckoutSessionRequest,
  CreateCheckoutSessionResponse,
  CreatePortalSessionRequest,
  CreatePortalSessionResponse,
} from "../types/requests";

export async function createCheckoutSession(
  planId: CreateCheckoutSessionRequest["planId"],
  origin: string,
): Promise<string> {
  const callable = httpsCallable<
    CreateCheckoutSessionRequest,
    CreateCheckoutSessionResponse
  >(functions, "createCheckoutSession");
  const result = await callable({ planId, origin });
  return result.data.url;
}

export async function createPortalSession(origin: string): Promise<string> {
  const callable = httpsCallable<
    CreatePortalSessionRequest,
    CreatePortalSessionResponse
  >(functions, "createPortalSession");
  const result = await callable({ origin });
  return result.data.url;
}
